import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b9e9dd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen screen-overlay" }
const _hoisted_2 = { class: "scenario-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scenario_text = _resolveComponent("scenario-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_scenario_text, { scenario: _ctx.scenario }, null, 8, ["scenario"])
    ]),
    _createElementVNode("button", {
      class: "btn-link action-right",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.complete && _ctx.complete(...args)))
    }, " Next Question ")
  ]))
}